import { useStaticQuery, graphql } from 'gatsby'

const useSiteData = () => {
  const data = useStaticQuery(
    graphql`
      query {
        siteData {
          blogSlug
          checkoutSlug
          currentLocale

          navigationPrimary {
            blogCategories {
              name
              id
            }
            mobileNavigationBackButtonText
            submenus {
              title
              contentType
              navigationGroups {
                label
                contentType
                pages {
                  contentName
                  navigationTitle
                  slug
                  canonicalSlug
                  travelizeProductCode
                  travelizeAdditionId
                  overviewText
                  heroLabel
                  heroTitle
                  title
                  intro
                  metaDataTitle
                  metaDataDescription
                  contentType
                  allPostsFilter
                  latestPostsCount
                  blogsPerPage
                  translationUpdated
                  slugs {
                    da_DK
                    de_DE
                    de_AT
                    de_CH
                    en_US
                    fr_FR
                    nb_NO
                    sv_SE
                  }
                  url
                }
              }
              page {
                navigationTitle
                slug
                heroLabel
                heroTitle
                title
                intro
                metaDataTitle
                metaDataDescription
                contentType
                url
                slugs {
                  da_DK
                    de_DE
                    de_AT
                    de_CH
                    en_US
                    fr_FR
                    nb_NO
                    sv_SE
                }
              }
            }
          }

          locales
          pageSettings {
            title
            signInText
            signInUrl
            footerFeatures {
              layout
              largeTitle
              icon
              contentType
              contentName
            }
            footerPrimaryNavTitle
            footerPrimaryNavLinks {
              contentType
              internalLink {
                slug
              }
              title
            }
            footerSecondaryNavTitle
            footerSecondaryNavLinks {
              contentType
              title
              url
              internalLink {
                slug
              }
            }
            footerSocialMediaTitle
            footerSocialMediaLinks {
              contentType
              link
              socialMediaTitle
            }
            footerContactTitle
            footerContactLink {
              contentType
              title
              url
            }
            footerInformationLinks {
              contentType
              title
              url
              internalLink {
                slug
              }
            }
            organisation
            footerNewsletterTitle
            footerNewsletterPlaceholder
            footerContactContent {
              nodeType
              content {
                nodeType
                content {
                  value
                  nodeType
                  content {
                    value
                    nodeType
                  }
                  data {
                    uri
                  }
                  marks {
                    type
                  }
                }
              }              
            }
            enableOptimizeAntiFlicker
            optimizeContainerId
            translations {
              day
              may
              tax
              book
              city
              days
              from
              july
              june
              male
              next
              open
              page
              room
              week
              april
              close
              email
              march
              reset
              rooms
              total
              weeks
              august
              course
              female
              gender
              goBack
              person
              postal
              remove
              address
              comment
              country
              january
              october
              persons
              summary
              continue
              december
              discount
              duration
              february
              lastName
              november
              previous
              readMore
              addForAll
              firstName
              insurance
              september
              travelers
              traveller
              dateOfBirth
              information
              mobilePhone
              chooseCourse
              chooseGender
              stillLoading
              courseOptions
              confirmBooking
              selectLanguage
              addCampaignCode
              latestBlogposts
              locationCourses
              moreInformation
              newsletterTerms
              campNotAvailable
              informationTerms
              noRoomsAvailable
              dateOfBirthSyntax
              wrongNumberOfBeds
              addTravelCompanion
              telToClosestFamily
              addonsAndActivities
              allPricesArePerPerson
              informationAndBooking
              noRoomsOrCoursesAvailable
              roomsWithOneEmptybedLabel
              roomsWithOneExtrabedLabel
              userInformationForPayment
              roomsWithTwoEmptybedsLabel
              roomsWithTwoExtrabedsLabel
              roomsWithFourEmptybedsLabel
              roomsWithFourExtrabedsLabel
              roomsWithThreeEmptybedsLabel
              roomsWithThreeExtrabedsLabel
              useUserInformationAsTraveller
              selectAvailableTripDatesToContinue
              showOnlyDatesWithDoubleRoomAvailable
              noBlogPostsFound
              travellerIsTooYoung
            }
          }
        }
      }
    `
  )
  return data.siteData
}

export default useSiteData
